var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('p',[_vm._v(_vm._s(_vm.$t("lang_welcome"))+" "+_vm._s(_vm.user_public_id))]),_c('p',[_vm._v(_vm._s(_vm.$t("lang_organisation"))+": "+_vm._s(_vm.user_organisation))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }